import MenuFeatured from './MenuFeatured'

export default MenuFeatured
